import React from "react";
import FlexBetween from "components/FlexBetween";
import Header from "components/Header";
import {
    AutoAwesome,
  CodeOutlined,
  EditOutlined,
  FeedOutlined, GridOnOutlined, PlayCircleFilled, PreviewOutlined,
} from "@mui/icons-material";
import {
  Box,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import SceneBox from "components/SceneBox";

export default function DevHub() {
  const theme = useTheme();
  const isNonMediumScreens = useMediaQuery("(min-width: 1200px)");
  
  return (
    <Box m="1.5rem 2.5rem">
        <FlexBetween>
            <Header title="DEV" subtitle="Quote Bot" />
            <Box>
            </Box>
        </FlexBetween>

        <Box
            mt="20px"
            display="grid"
            gridTemplateColumns="repeat(12, 1fr)"
            gridAutoRows="160px"
            gap="20px"
            sx={{
            "& > div": { gridColumn: isNonMediumScreens ? undefined : "span 12" },
            }}
        >
            {/* ROW 1 */}
            <SceneBox
            value="AidaForm"
            onClick={() => {
                    window.open('https://flairflow.aidaform.com/questionnaire-ev-nement-flair-flow-copy');
                }}
            icon={
                <FeedOutlined
                sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
                />
            }
            />
            <SceneBox
            value="Sheets"
            onClick={() => {
                    window.open('https://docs.google.com/spreadsheets/d/1F-DkcvycUFBJhWcEgElryt2wcZ2knCI4NOo2VLEYbqU/edit?usp=drive_link');
                }}
            icon={
                <GridOnOutlined
                sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
                />
            }
            />
            <SceneBox
            value="Make Scenario"
            onClick={() => {
                    window.open('https://eu1.make.com/287813/scenarios/1774119/edit');
                }}
            icon={
                <AutoAwesome
                sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
                />
            }
            />
            <SceneBox
            value="Code"
            onClick={() => {
                    window.open('https://docs.google.com/document/d/1AAN-23E-OrKOhyssTmX_O4vI7lwshj9cyhWhzsBvoo4/edit?usp=drive_link');
                }}
            icon={
                <CodeOutlined
                sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
                />
            }
            />
                
        </Box>
            
        <FlexBetween marginTop={5}>
            <Header title="" subtitle="Liste de Course Bot" />
            <Box>
            </Box>
        </FlexBetween>
        <Box
            mt="20px"
            display="grid"
            gridTemplateColumns="repeat(12, 1fr)"
            gridAutoRows="160px"
            gap="20px"
            sx={{
            "& > div": { gridColumn: isNonMediumScreens ? undefined : "span 12" },
            }}
        >
            {/* ROW 2 */}
            <SceneBox
            value="AidaForm"
            onClick={() => {
                    window.open('https://flairflow.aidaform.com/Selectioncocktails');
                }}
            icon={
                <FeedOutlined
                sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
                />
            }
            />
            <SceneBox
            value="Sheets"
            onClick={() => {
                    window.open('https://docs.google.com/spreadsheets/d/1JxB6AeD9gRAXWQNKUiZyBLmpnhNsbFu2wePUebp1Av8/edit?usp=drive_link');
                }}
            icon={
                <GridOnOutlined
                sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
                />
            }
            />
            <SceneBox
            value="Make Scenario"
            onClick={() => {
                    window.open('https://eu1.make.com/287813/scenarios/1073909/edit');
                }}
            icon={
                <AutoAwesome
                sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
                />
            }
            />
            <SceneBox
            value="Code"
            onClick={() => {
                    window.open('https://docs.google.com/document/d/1yq_BudkIFLY1dUBN3JBFipqvKZmGWDBF4wOvSoTX9dM/edit?usp=drive_link');
                }}
            icon={
                <CodeOutlined
                sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
                />
            }
            />
                
          </Box>
        <FlexBetween marginTop={5}>
            <Header title="" subtitle="Atelier Bot" />
            <Box>
            </Box>
        </FlexBetween>
        <Box
            mt="20px"
            display="grid"
            gridTemplateColumns="repeat(12, 1fr)"
            gridAutoRows="160px"
            gap="20px"
            sx={{
            "& > div": { gridColumn: isNonMediumScreens ? undefined : "span 12" },
            }}
        >
            {/* ROW 2 */}
            <SceneBox
            value="AidaForm"
            onClick={() => {
                    window.open('https://flairflow.aidaform.com/atelier-questionnaire-devis');
                }}
            icon={
                <FeedOutlined
                sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
                />
            }
            />
            <SceneBox
            value="Sheets"
            onClick={() => {
                    window.open('https://docs.google.com/spreadsheets/d/1Zlley42N5yiXWA93t-PIZDn9dqht2bEU-9Rp9P-NI-w/edit?usp=drive_link');
                }}
            icon={
                <GridOnOutlined
                sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
                />
            }
            />
            <SceneBox
            value="Code"
            onClick={() => {
                    window.open('https://docs.google.com/document/d/1AM8xONfGWgtiMFVshD00CIiL_P4VTjK0Z4rEQdZ0Swg/edit?usp=drive_link');
                }}
            icon={
                <CodeOutlined
                sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
                />
            }
            />
                
        </Box>
          
        <FlexBetween marginTop={5}>
            <Header title="" subtitle="Make" />
            <Box>
            </Box>
        </FlexBetween>
        <Box
            mt="20px"
            display="grid"
            gridTemplateColumns="repeat(12, 1fr)"
            gridAutoRows="160px"
            gap="20px"
            sx={{
            "& > div": { gridColumn: isNonMediumScreens ? undefined : "span 12" },
            }}
        >
            {/* ROW 4 */}
            
            <SceneBox
            value="See All Scenarios"
            onClick={() => {
                    window.open('https://eu1.make.com/287813/scenarios?folder=all&tab=all');
                }}
            icon={
                <PreviewOutlined
                sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
                />
            }
            />
                            
        </Box>
          
        <FlexBetween marginTop={5}>
            <Header title="" subtitle="Wix" />
            <Box>
            </Box>
        </FlexBetween>
        <Box
            mt="20px"
            display="grid"
            gridTemplateColumns="repeat(12, 1fr)"
            gridAutoRows="160px"
            gap="20px"
            sx={{
            "& > div": { gridColumn: isNonMediumScreens ? undefined : "span 12" },
            }}
        >
            {/* ROW 4 */}
            <SceneBox
            value="Edit Website"
            onClick={() => {
                    window.open('https://editor.wix.com/html/editor/web/renderer/edit/f818502d-ca78-4a02-9c46-418e4fe0cad9?metaSiteId=e24156e1-e4ef-449c-be66-3cfc8602be7a');
                }}
            icon={
                <EditOutlined
                sx={{ color: theme.palette.secondary[500], fontSize: "36px" }}
                />
            }
              />
        </Box>
        
    </Box>
  );
};